import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import What from './views/public/What.vue';
import How from './views/public/How.vue';
import Pricing from './views/public/Pricing.vue';
import SignIn from './views/public/SignIn.vue';
import MemberBankAccounts from './views/member/MemberBankAccounts.vue';

import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { title: 'Tame Your Cash', requiresAuth: false},
    },
    {
      path: '/what',
      name: 'what',
      component: What,
      meta: { title: 'What Is It', requiresAuth: false},
    },
    {
      path: '/how',
      name: 'how',
      component: How,
      meta: { title: 'How It Works', requiresAuth: false},
    },
    {
      path: '/watch',
      name: 'watch',
      component: () => import('./views/public/Watch.vue'),
      meta: { title: 'Watch', requiresAuth: false},
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/public/About.vue'),
      meta: { title: 'About', requiresAuth: false},
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: Pricing,
      meta: { title: 'Pricing', requiresAuth: false},
    },
    {
      path: '/signin',
      name: 'signin',
      component: SignIn,
      meta: { title: 'Sign In', requiresAuth: false},
    },
    {
      path: '/join',
      name: 'join',
      component: () => import('./views/public/Join.vue'),
      meta: { title: 'Join', requiresAuth: false},
    },
    {
      path: '/joinverify',
      name: 'joinverify',
      component: () => import('./views/public/JoinVerify.vue'),
      meta: { title: 'Join Verification', requiresAuth: false},
    },
    {
      path: '/joinreissue',
      name: 'joinreissue',
      component: () => import('./views/public/JoinReissue.vue'),
      meta: { title: 'Join Reissue', requiresAuth: false},
    },
    {
      path: '/signinpause',
      name: 'signinpause',
      component: () => import('./views/public/SignInPause.vue'),
      meta: { title: 'Sign In', requiresAuth: false},
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('./views/public/Terms.vue'),
      meta: { title: 'Terms', requiresAuth: false},
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('./views/public/Privacy.vue'),
      meta: { title: 'Privacy', requiresAuth: false},
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/public/Contact.vue'),
      meta: { title: 'Contact Us', requiresAuth: false},
    },
    {
      path: '/primarypassword/initiatereset',
      name: 'primarypasswordinitiatereset',
      component: () => import('./views/public/InitiatePrimaryPasswordReset.vue'),
      meta: { title: 'Initiate Password Reset', requiresAuth: false},
    },
    {
      path: '/primarypassword/reset',
      name: 'primarypasswordreset',
      component: () => import('./views/public/ResetPrimaryPassword.vue'),
      meta: { title: 'Reset Password', requiresAuth: false},
    },
    {
      path: '/member/bankaccounts',
      name: 'memberbankaccounts',
      component: MemberBankAccounts,
      meta: { title: 'Member Bank Accounts', requiresAuth: true},
    },
    {
      path: '/member/welcome',
      name: 'memberwelcome',
      component: () => import('./views/member/MemberWelcome.vue'),
      meta: { title: 'Member Welcome', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/purchase',
      name: 'memberpurchasebankaccounts',
      component: () => import('./views/member/MemberPurchaseBankAccounts.vue'),
      meta: { title: 'Purchase Bank Account', requiresAuth: true},
    },
    {
      path: '/member',
      name: 'memberprofile',
      component: () => import('./views/member/MemberProfile.vue'),
      meta: { title: 'Member Profile', requiresAuth: true},
    },
    {
      path: '/member/name',
      name: 'memberchangename',
      component: () => import('./views/member/MemberChangeName.vue'),
      meta: { title: 'Change Member Name', requiresAuth: true},
    },
    {
      path: '/member/primarypassword',
      name: 'memberchangeprimarypassword',
      component: () => import('./views/member/MemberChangePrimaryPassword.vue'),
      meta: { title: 'Change Member Primary Password', requiresAuth: true},
    },
    {
      path: '/member/backuppassword',
      name: 'memberchangebackuppassword',
      component: () => import('./views/member/MemberChangeBackupPassword.vue'),
      meta: { title: 'Change Member Backup Password', requiresAuth: true},
    },
    {
      path: '/member/email/initiatechange',
      name: 'memberinitiateemailchange',
      component: () => import('./views/member/MemberInitiateEmailAddressChange.vue'),
      meta: { title: 'Initiate Member Email Change', requiresAuth: true},
    },
    {
      path: '/member/email',
      name: 'memberchangeemailaddress',
      component: () => import('./views/member/MemberChangeEmailAddress.vue'),
      meta: { title: 'Change Member Email', requiresAuth: true},
    },
    {
      path: '/member/logs',
      name: 'memberlogs',
      component: () => import('./views/member/MemberLogs.vue'),
      meta: { title: 'Member Logs', requiresAuth: true},
    },
    {
      path: '/member/orders',
      name: 'memberorders',
      component: () => import('./views/member/MemberOrders.vue'),
      meta: { title: 'Member Orders', requiresAuth: true},
    },
    {
      path: '/member/communications',
      name: 'membercommunications',
      component: () => import('./views/member/MemberCommunications.vue'),
      meta: { title: 'Member Communications', requiresAuth: true},
    },
    {
      path: '/member/delete',
      name: 'memberdelete',
      component: () => import('./views/member/MemberDelete.vue'),
      meta: { title: 'Delete Membership', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId',
      name: 'bankaccountdashboard',
      component: () => import('./views/bankaccounts/BankAccountDashboard.vue'),
      props: true,
      meta: { title: 'Bank Account', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/adjust',
      name: 'bankaccountadjust',
      component: () => import('./views/bankaccounts/BankAccountAdjustBalance.vue'),
      props: true,
      meta: { title: 'Adjust Bank Account', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/delete',
      name: 'bankaccountdelete',
      component: () => import('./views/bankaccounts/BankAccountDelete.vue'),
      props: true,
      meta: { title: 'Delete Bank Account', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/deposit',
      name: 'bankaccountdeposit',
      component: () => import('./views/bankaccounts/BankAccountDeposit.vue'),
      props: true,
      meta: { title: 'Bank Account Deposit', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/transfer',
      name: 'bankaccounttransfer',
      component: () => import('./views/bankaccounts/BankAccountTransfer.vue'),
      props: true,
      meta: { title: 'Bank Account Transfer', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/obligate',
      name: 'bankaccountobligate',
      component: () => import('./views/bankaccounts/BankAccountObligate.vue'),
      props: true,
      meta: { title: 'Bank Account Obligate', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/createfund',
      name: 'bankaccountcreatefund',
      component: () => import('./views/bankaccounts/BankAccountCreateFund.vue'),
      props: true,
      meta: { title: 'Create Fund', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/createmember',
      name: 'bankaccountcreatemember',
      component: () => import('./views/bankaccounts/BankAccountCreateMember.vue'),
      props: true,
      meta: { title: 'Add Member', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/actualbalance',
      name: 'bankaccountchangeactualbalance',
      component: () => import('./views/bankaccounts/BankAccountChangeActualBankBalance.vue'),
      props: true,
      meta: { title: 'Change Bank Account Actual Balance', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/name',
      name: 'bankaccountchangename',
      component: () => import('./views/bankaccounts/BankAccountChangeName.vue'),
      props: true,
      meta: { title: 'Change Bank Account Name', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/notes',
      name: 'bankaccountchangenotes',
      component: () => import('./views/bankaccounts/BankAccountChangeNotes.vue'),
      props: true,
      meta: { title: 'Change Bank Account Notes', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/logs',
      name: 'bankaccountlogs',
      component: () => import('./views/bankaccounts/BankAccountLogs.vue'),
      props: true,
      meta: { title: 'Bank Account Logs', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/backups',
      name: 'bankaccountbackups',
      component: () => import('./views/bankaccounts/BankAccountBackups.vue'),
      props: true,
      meta: { title: 'Bank Account Backups', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/members',
      name: 'bankaccountmembers',
      component: () => import('./views/bankaccounts/BankAccountMembers.vue'),
      props: true,
      meta: { title: 'Bank Account Members', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/members/:bankAccountMemberId',
      name: 'bankaccountmember',
      component: () => import('./views/bankaccountmembers/BankAccountMemberDashboard.vue'),
      props: true,
      meta: { title: 'Bank Account Member', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/members/:bankAccountMemberId/role',
      name: 'bankaccountmemberchangerole',
      component: () => import('./views/bankaccountmembers/BankAccountMemberChangeRole.vue'),
      props: true,
      meta: { title: 'Change Bank Account Member Role', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/members/:bankAccountMemberId/delete',
      name: 'bankaccountmemberdelete',
      component: () => import('./views/bankaccountmembers/BankAccountMemberDelete.vue'),
      props: true,
      meta: { title: 'Delete Bank Account Member', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/transactions',
      name: 'bankaccounttransactions',
      component: () => import('./views/bankaccounts/BankAccountTransactions.vue'),
      props: true,
      meta: { title: 'Bank Account Transactions', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/purchasefunds',
      name: 'bankaccountpurchasefunds',
      component: () => import('./views/bankaccounts/BankAccountPurchaseFunds.vue'),
      props: true,
      meta: { title: 'Purchase Funds', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/purchasetransactions',
      name: 'bankaccountpurchasetransactions',
      component: () => import('./views/bankaccounts/BankAccountPurchaseTransactions.vue'),
      props: true,
      meta: { title: 'Purchase Transactions', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/funds/:fundId',
      name: 'funddashboard',
      component: () => import('./views/funds/FundDashboard.vue'),
      props: true,
      meta: { title: 'Fund', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/funds/:fundId/payment',
      name: 'fundpayment',
      component: () => import('./views/funds/FundPayment.vue'),
      props: true,
      meta: { title: 'Fund Payment', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/funds/:fundId/transfer',
      name: 'fundtransfer',
      component: () => import('./views/funds/FundTransfer.vue'),
      props: true,
      meta: { title: 'Fund Transfer', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/funds/:fundId/name',
      name: 'fundchangename',
      component: () => import('./views/funds/FundChangeName.vue'),
      props: true,
      meta: { title: 'Change Fund Name', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/funds/:fundId/notes',
      name: 'fundchangenotes',
      component: () => import('./views/funds/FundChangeNotes.vue'),
      props: true,
      meta: { title: 'Change Fund Notes', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/funds/:fundId/logs',
      name: 'fundlogs',
      component: () => import('./views/funds/FundLogs.vue'),
      props: true,
      meta: { title: 'Fund Logs', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/funds/:fundId/transactions',
      name: 'fundtransactions',
      component: () => import('./views/funds/FundTransactions.vue'),
      props: true,
      meta: { title: 'Fund Transactions', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/funds/:fundId/delete',
      name: 'funddelete',
      component: () => import('./views/funds/FundDelete.vue'),
      props: true,
      meta: { title: 'Delete Fund', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/funds/:fundId/transactions/:transactionId',
      name: 'transactiondashboard',
      component: () => import('./views/transactions/TransactionDashboard.vue'),
      props: true,
      meta: { title: 'Transaction', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/funds/:fundId/transactions/:transactionId/logs',
      name: 'transactionlogs',
      component: () => import('./views/transactions/TransactionLogs.vue'),
      props: true,
      meta: { title: 'Transaction Logs', requiresAuth: true},
    },
    {
      path: '/member/bankaccounts/:bankAccountId/funds/:fundId/transactions/:transactionId/details',
      name: 'transactionchangedetails',
      component: () => import('./views/transactions/TransactionChangeDetails.vue'),
      props: true,
      meta: { title: 'Change Transaction Details', requiresAuth: true},
    },
    {
      path: '*',
      component: Home,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
});

router.beforeEach( (to, from, next) => {
  if (to.meta && to.meta.requiresAuth) {
    if ( store.state.member.authenticated ) {
      next();
    }
    else {
      next({name: 'signin'});
    }
  }
  else {
    next();
  }
});

router.afterEach((to, from) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + ' | CashTamer';
  }
});


export default router;
